document.addEventListener('DOMContentLoaded', function() {
  setTimeout(() => {
    const quantityWrappers = document.querySelectorAll('[data-quantity-wrapper]');

    quantityWrappers.forEach(wrapper => {
      const input = wrapper.querySelector('[data-quantity-input]');
      const minusButton = wrapper.querySelector('[data-quantity-minus]');
      const plusButton = wrapper.querySelector('[data-quantity-plus]');

      if (!input || !minusButton || !plusButton) return;

      // Re-entrancy guard: updateQuantity dispatches a 'change' event, and the manual-input
      // 'change' listener below calls updateQuantity - without this flag that forms an infinite
      // loop (RangeError: Maximum call stack size exceeded). Other 'change'/cart listeners still
      // fire on the dispatched event; only the recursive re-entry into updateQuantity is blocked.
      let isUpdatingQuantity = false;

      function updateQuantity(newValue) {
        if (isUpdatingQuantity) return;
        isUpdatingQuantity = true;

        // Allow 0 as a valid quantity
        newValue = Math.max(0, parseInt(newValue) || 0);
        input.value = newValue;

        // Trigger the input event to update cart
        const event = new Event('change', { bubbles: true });
        input.dispatchEvent(event);

        // If there's a form, submit it
        const form = input.closest('form');
        if (form) {
          form.dispatchEvent(new Event('submit', { bubbles: true }));
        }

        isUpdatingQuantity = false;
      }

      minusButton.addEventListener('click', (e) => {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 0;
        updateQuantity(currentValue - 1);
      });

      plusButton.addEventListener('click', (e) => {
        e.preventDefault();
        const currentValue = parseInt(input.value) || 0;
        updateQuantity(currentValue + 1);
      });

      // Handle manual input
      input.addEventListener('change', () => {
        updateQuantity(input.value);
      });

      // Prevent form submission on button click
      minusButton.addEventListener('submit', (e) => e.preventDefault());
      plusButton.addEventListener('submit', (e) => e.preventDefault());
    });
  }, 200);
}); 